module.exports = __webpack_public_path__ + "static/media/_basque-country.957267be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_basque-country.svg
// module id = 2303
// module chunks = 7